export default __webpack_public_path__ + "static/media/expl_09_EN.54690257.png";